import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPercent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={16}
    fill="none"
    viewBox="0 0 14 16"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.66 7.33C1.75 7.33.333 5.892.333 4.08.333 2.29 1.751.833 3.66.833c1.89 0 3.307 1.418 3.307 3.248 0 1.811-1.397 3.249-3.307 3.249m-1.93 5.472 8.978-9.98 1.2.669-8.996 10zm1.91-7.46c.729 0 1.24-.572 1.24-1.26 0-.69-.511-1.24-1.24-1.24-.708 0-1.22.55-1.22 1.24 0 .708.512 1.26 1.22 1.26m6.674 9.783c-1.91 0-3.307-1.457-3.307-3.248 0-1.792 1.397-3.248 3.307-3.248s3.307 1.457 3.307 3.248c0 1.791-1.398 3.248-3.307 3.248m0-1.988c.728 0 1.22-.59 1.22-1.26 0-.709-.492-1.26-1.22-1.26-.729 0-1.22.551-1.22 1.26s.491 1.26 1.22 1.26"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPercent;
